import { ShaftLengthDigit, ShaftLengthFraction, Digit, Fraction } from '@/api/models';
import { sortByPropKey } from '@/utils';

export interface ShaftLengthOption {
  digit: string;
  joinTableDigitId: number;
  sourceTableDigitId: number | null;
  fraction: string;
  joinTableFractionId: number;
  sourceTableFractionId: number | null;
}

export interface ShaftLengthOptionMap {
  map: Record<string, ShaftLengthOption>;
  options: { id: string; label: string }[];
}

interface IBuildDropdownData {
  digitJoinTable: ShaftLengthDigit[];
  fractionJoinTable: ShaftLengthFraction[];
  digitSourceTable: Digit[];
  fractionSourceTable: Fraction[];
}

export const buildDropdownData = ({ digitJoinTable, fractionJoinTable, digitSourceTable, fractionSourceTable }: IBuildDropdownData) => {
  return digitJoinTable.sort(sortByPropKey<ShaftLengthDigit>('digitId')).reduce<ShaftLengthOptionMap>(
    (acc, digitJoinTableItem) => {
      fractionJoinTable.forEach((fractionJoinTableItem) => {
        const digitEntity = digitSourceTable.find((d) => d.digitId === digitJoinTableItem.digitId);
        const fractionEntity = fractionSourceTable.find((f) => f.fractionId === fractionJoinTableItem.fractionId);
        const displayName = `${digitEntity?.name} ${fractionEntity?.name}`;

        const option: ShaftLengthOption = {
          digit: digitEntity?.name || '',
          joinTableDigitId: digitJoinTableItem.shaftLengthDigitId,
          sourceTableDigitId: digitEntity?.digitId || null,
          fraction: fractionEntity?.name || '',
          joinTableFractionId: fractionJoinTableItem.shaftLengthFractionId,
          sourceTableFractionId: fractionEntity?.fractionId || null,
        };

        acc.map[displayName] = option;
        acc.options.push({ id: displayName, label: displayName });
      });

      return acc;
    },
    { map: {}, options: [] },
  );
};
